/**
 * An HTML DOM element.
 * @typedef {Object} HTMLElement
 */

/**
 * The built in window Event object.
 * @typedef {Object} Event
 */

 /**
 * The global jQuery object.
 * @typedef {Object} jQuery
 */

/**
 * @typedef {Object} WSFormRequirement
 * @property {boolean} required - This field is required.
 */
(function($, ob_set) {
	// require WS utility namespace
	if (typeof WS === "undefined") {
		throw new Error("Whitespace utility namespace does not exist");
	}

	$.fn.extend({
		formOffset: function() {
			// data the offset from element to the form
			var element, pos;

			pos = [];

			if (!(element = $(this))) {
				// element can't be retrieved - return false
				return false;
			}

			if (element[0].tagName === "FORM") {
				// element is the form - return base offset
				return {
					'left': 0,
					'top': 0
				};
			}

			pos = {
				'left': element[0].offsetLeft,
				'top': element[0].offsetTop
			};

			while ((element = element.offsetParent()).length > 0) {
				if (element[0].tagName === "FORM" || element[0].tagName === "HTML") {
					// break if form tag (or for some reason the HTML tag) is found
					break;
				}

				pos.left += element[0].offsetLeft;
				pos.top += element[0].offsetTop;
			}

			return pos;
		}
	});

	/**
	 * @namespace WS
	 */

	/**
	 * Callback for handling global contextual popup dialogs.
	 * @callback WS.Form.PopupHandler
	 * @arg {*} context - A jquery extended DOM element, or `undefined` if no context is required.
	 * @arg {Object} options - The contents of `popup.options` or `field.popup.options` from
	 * {@link WS.FormOptions}.
	 * @arg {string} message - The message to display.
	 * @this WS.Form
	 */

	/**
	 * Calback for handling field contextual popup dialogs.
	 * @callback WS.Form.FieldPopupHandler
	 * @arg {*} context - A jquery extended DOM element, or `undefined` if no context is required.
	 * @arg {Object} options - The contents of `popup.options` or `field.popup.options` from
	 * {@link WS.FormOptions}.
	 * @arg {string} message - The message to display.
	 * @this WS.Form
	 */

	/**
	 * Calback for handling field contextual popup dialogs.
	 * @callback WS.FormSubmit
	 * @arg {HTMLElement} form - The HTMLElement form being handled.
	 * @this WS.Form
	 */

	/**
	 * The full set of default options available to WS.Form.
	 * @typedef {Object} WSFormOptions
	 * @property {boolean} halt - Set `true` to halt form submission before checking validity.
	 * When set to `false`, will only stop submission when the form is known to contain invalid elements.
	 * @property {Object} popup - Default options for the popup dialog.
	 * @property {WS.Form.PopupHandler} popup.handler - Define here a function for handling global popup
	 * dialogs. When defined, your function will be called instead of the original popup dialog.
	 * @property {number} popup.type=WS.Form.MsgTypes.Message - Type of dialog box.
	 * @property {number} popup.alignment=WS.Form.Alignments.top_right
	 * @property {number} popup.margin=4 - Margin (in px) for the dialog box.
	 * @property {number} popup.zindex=3000 - CSS z-index of the dialog box.
	 * @property {Object} field - Field default options.
	 * @property {Object} field.popup - Field popup options.
	 * @property {WS.Form.FieldPopupHandler} field.popup.handler - Similar in purpose to popup.handler,
	 * but for field specific popup dialogs.
	 * @property {number} field.popup.alignment=WS.Form.Alignments.top_left
	 * @property {boolean} show_name=false - Show the name of the field in the popup, regardless
	 * of whether or not it's a `placeholder` type.
	 * @property {*} tabs=false - See example for tab usage.
	 * @property {string} tabs.title - Tab group title.
	 * @property {Array} tabs.fieldsets - An array of string IDs or {@link HTMLElement} elements defining
	 * each fieldset for this tab group.
	 * @property {Object} classes - A key/value pair of the classes and their new classnames. (See below).
	 * @property {Object} submit - Submission options. Unavailable when `halt` is disabled.
	 * @property {string} submit.method=null - One of the {@link WS.Form.SubmitMethods} methods to use
	 * for submitting.
	 * If not defined, the form's default submission method is used.
	 * @property {WS.FormSubmit} submit.callback - An optional callback to execute, instead of
	 * submitting the form.
	 * @memberof WS.Form
	 * @description
	 * ##### Using tabs
	 *
	 * Tabs can be created in one of two ways. Either set the property to `true` to use simple tabs to seperate
	 * the visible non-control fieldsets on the form, or create as an Array of Objects to customise grouped
	 * fieldsets within each tab. The following shows an example of the Array syntax:
	 *
	 * ```javascript
	 * [{
	 *     'title': 'Your Tab Title',
	 *     'fieldsets': ['fieldset_1_id', 'fieldset_2_id']
	 * }, {
	 *     'title': 'Another Tab Title',
	 *     'fieldsets': ['fieldset_3_id']
	 * }]
	 * ```
	 *
	 * Fieldsets will be grouped within tabs, which will labelled as the `title` property defines. Fieldsets
	 * not included within the object will be left as is, becoming omnipresent on the form.
	 */

	/**
	 * @event WS.Form#submitting
	 * @arg {Event} event
	 * @arg {string} method One of the {@link WS.Form.SubmitMethods} methods. This may not be the
	 * method of the form as predetermined by the HTML, but could be redefined by the
	 * initialization options.
	 */

	/**
	 * @event WS.Form#submitted
	 * @arg {Event} event
	 * @arg {string} data - The response data.
	 * @arg {string} status - The response status.
	 * @arg {Object} jqXHR - The jQuery XHR implementation.
	 * @description
	 * Fired on the managed form when an AJAX type submission has completed.
	 * Arguments are as the usual 'success' response (see: http://api.jquery.com/jQuery.ajax/)
	 */

	/**
	 * @event WS.Form#error
	 * @arg {Event} event
	 * @arg {jQuery} form - The jQuery extended form HTMLElement.
	 * @arg {Array} faults - An array of fault data.
	 */

	/**
	 * @class
	 * @version 1.0.2
	 * @arg {HTMLElement} form The HTML form element.
	 * @arg {WS.Form.WSFormOptions} options An options object.
	 * @arg {Object} fields A field definition.
	 */
	WS.Form = function(form, options, fields) {
		var cls, my;

		// !public interface
		cls = {
			/**
			 * @function WS.Form#validate
			 * @returns {boolean} `true` if validation succeeded, `false` otherwise.
			 * @description
			 * Validates a form, using the stored field data.
			 */
			validate: function() {
				return my.validate.apply(this, arguments);
			},

			/**
			 * @function WS.Form#validate_field
			 * @arg {string} name - Name attribute value of the field to validate.
			 * @arg {WSFormRequirement} check - Single requirement specification for this field.
			 * @returns {Object} Instance of {@link WS.Form.Result}
			 * @description
			 * Validate a single field by name.
			 */
			validate_field: function() {
				return my.validate_field.apply(this, arguments);
			},

			/**
			 * @function WS.Form#value
			 */
			value: function() {
				return my.value.apply(this, arguments);
			},

			/**
			 * ƒfunction WS.Form#tab
			 */
			tab: function(index) {
				if (my.tabs.items && my.tabs.items[index]) {
					// switch tab
					my.tabs.items[my.tabs.index].hide();
					my.tabs.items[index].show();

					// switch navigation
					my.tabs.control.children("li").slice(my.tabs.index, (my.tabs.index + 1)).removeClass("active");
					my.tabs.control.children("li").slice(index, (index + 1)).addClass("active");

					// set new index
					my.tabs.index = index;

					// clear message
					my.message("");

					return my.tabs.items[index];
				} else {
					return false;
				}
			},

			/**
			 * @function WS.Form#tabs
			 */
			tabs: function(index) {
				return my.tabs.items;
			},

			/**
			 * @function WS.Form#has_field
			 */
			has_field: function(field_name, options) {
				return !!(my.fields[field_name]);
			},

			/**
			 * @function WS.Form#add_field
			 */
			add_field: function(field_name, options) {
				var field;

				if (!form[0][field_name] || !(field = form[0][field_name])) {
					throw new Error("Form does not contain element with name '" + field_name + "'");
				}

				if (cls.has_field(field_name)) {
					return false;
				}

				my.fields[field_name] = options;

				form.find(my.options.selectors.elements.join(",")).each(function() {
					var element;

					element = $(this);

					if (element.attr("name") === field_name) {
						my.parse_element(element);
					}
				});

				return true;
			},

			/**
			 * @function WS.Form#remove_field
			 */
			remove_field: function(field_name) {
				if (my.fields[field_name]) {
					my.clear(field_name);
					delete my.fields[field_name];
					return true;
				} else {
					return false;
				}
			},

			/**
			 * @function WS.Form#add_fault
			 */
			add_fault: function(result) {
				var field;

				if (!(result instanceof Object) ||
					typeof result.valid !== "boolean") {
					throw new Error("Invalid WS.Form.Result Object passed");
				}

				if (typeof result.name !== "string" && result.name.length <= 0) {
					throw new Error("Result property 'name' must be set");
				} else if (!form[0][result.name] || !(field = form[0][result.name])) {
					throw new Error("Form does not contain element with name '" + result.name + "'");
				}

				this.remove_fault(result.name);

				my.faults.push(result);

				return result;
			},

			/**
			 * @function WS.Form#remove_fault
			 */
			remove_fault: function(name) {
				var a;

				for (a = 0; a != my.faults.length; a += 1) {
					if (my.faults[a].name === name) {
						my.faults.splice(a, 1);
						return true;
					}
				}

				return false;
			},

			/**
			 * @function WS.Form#report
			 */
			report: function() {
				return my.report.apply(this, arguments);
			},

			/**
			 * @function WS.Form#reset
			 */
			reset: function() {
				return my.reset.apply(this, arguments);
			},

			/**
			 * @function WS.Form#message
			 */
			message: function() {
				return my.message.apply(this, arguments);
			},

			/**
			 * @function WS.Form#popup
			 */
			popup: function() {
				return my.popup.apply(this, arguments);
			},

			/**
			 * @function WS.Form#clearPlaceholders
			 */
			clearPlaceholders: function() {
				return my.clear.apply(this, arguments);
			},

			/**
			 * @function WS.Form#restorePlaceholders
			 */
			restorePlaceholders: function() {
				return my.restore_placeholders.apply(this, arguments);
			}
		};

		my = {
			elements: {},

			fields: {},

			controls: {},

			timers: {},

			options: ob_set(options || {}, {
				'halt': true,
				'tabs': false,
				'popup': {
					'type': WS.Form.MsgTypes.Message,
					'alignment': WS.Form.Alignments.top_right,
					'margin': 4,
					'zindex': 4000
				},
				'field': {
					'popup': {
						'alignment': WS.Form.Alignments.bottom_right
					},
					'show_name': false
				},
				'submit': {
					'method': null,
					'callback': null
				},
				'live_validate': {
					'enabled': true,
					'delay': 0.5
				},
				'messages': {},
				'selectors': {
					'elements': [
						'input',
						'textarea',
						'select'
					]
				}
			}),

			faults: [],

			validation_re: {
				'email': new RegExp("^[^\\s]+@[^\\s]+(\\.[a-z.]*)?$", "i"),
				'number': new RegExp("^[0-9.+e]+$"),
				'date_iso': new RegExp("^(\\d{4})-(\\d\\d)-(\\d\\d)$"),
				'date': new RegExp("^(\\d\\d)([\\-\\/\\\\])(\\d\\d)\\2(\\d{4})$"),
				'email_parts': new RegExp("(.*)\\@([^.]*)\\.(.*)")
			},

			data: {
				'mail_domains': [
					"yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com",
					"live.com", "comcast.net", "googlemail.com", "msn.com", "hotmail.co.uk", "yahoo.co.uk",
					"facebook.com", "verizon.net", "sbcglobal.net", "att.net", "gmx.com", "mail.com", "whitespacers.com"
				]
			},

			classes: {
				'form': 'ws-form',
				'ph': 'placeholder',
				'ph_active': 'placeholder-active',
				'ph_inactive': 'placeholder-inactive',
				'label_text': 'label-text',
				'fieldset_control': 'control',
				'tab_control': 'form-tab-control',
				'tab_group': 'tab-group',
				'popup': 'form-handler-popup'
			},

			collectives: ["input[type = 'checkbox']", "input[type = 'radio']"],

			unlabelled: ['button', 'hidden', 'submit', 'image'],

			nontext_input_types: ['date', 'datetime', 'datetime-local', 'month', 'week', 'time', 'number', 'range', 'color'],

			enable: function() {
				var fn, submit_buttons, a, fieldsets;

				/**
				 * HTMLElement referencing the form object passed.
				 * @alias WS.Form#form
				 * @memberof! WS.Form
				 * @fires WS.Form#submitting
				 * @fires WS.Form#submitted
				 * @fires WS.Form#error
				 */
				cls.form = form;

				form = $(form);

				if (typeof my.options.classes === "object") {
					my.classes = ob_set(my.options.classes, my.classes);
				}

				/**
				 * @alias WS.Form#messages
				 * @memberof! WS.Form
				 */
				cls.messages = window.ob_set(my.options.messages, WS.Form.Messages);

				fn = {};

				// get and test form id
				my.form_id = form[0].id || form.attr("name");

				if (my.form_id !== null && typeof my.form_id !== "string") {
					throw new Error("Type error with form ID. The form id or name attribute " +
						"cannot be collected. This is likely due to an element with the name or " +
						"id of 'id'.");
				}

				// get field definition
				my.fields = ob_set(WS.Form.Fields[my.form_id] || {}, fields);

				// create ui object
				my.ui = {};

				// get form elements
				my.form_elements = form.find(my.options.selectors.elements.join(","));

				my.form_elements.each(function() {
					my.parse_element(this);
				});

				if (my.form_elements.length > 0) {
					form.addClass(
						my.classes.form
					).data(
						"ws_form", true
					).bind(
						"submit", my.event
					).bind(
						"click", my.event
					).bind(
						"keyup", my.event
					);

					if (form.css("position") !== "absolute") {
						form.css({
							'position': 'relative'
						});
					}

					// add popup element
					form.append(
						my.ui.popup = $("<div>", {
							'class': my.classes.popup
						}).css({
							'position': 'absolute',
							'white-space': 'nowrap',
							'zIndex': my.options.popup.zindex
						}).hide()
					);

					// add "novalidate" property to stop browser validation
					form.attr("novalidate", "novalidate");

					// find first visible submit button
					submit_buttons = form.find([
						"input[type = 'submit']",
						"input[type = 'image']",
						"button[type = 'submit']"
					].join(",")).filter(":visible");

					if (submit_buttons.length > 0) {
						my.controls.submit = submit_buttons.first();
					} else {
						my.log("No visible submit button could be found for this form. Global errors will be registered to form context.");
					}
				}

				// tab control
				if (my.options.tabs) {
					fieldsets = form.find("fieldset:not([class~='control'])");

					my.tabs = {
						'items': []
					};

					form.prepend(
						my.tabs.control = $("<ul>", {
							'class': my.classes.tab_control
						})
					);

					fn.add_tab = function(fieldset) {
						// prepares fieldsets as tabbed groups
						var control_class, legend, index, label;

						legend = fieldset.find("legend").first();
						index = my.tabs.items.length;

						// get class name
						if (index === 0) {
							control_class = "first active";
						} else if (index === (fieldsets.length - 1)) {
							control_class = "last";
						} else {
							control_class = null;
						}

						// get label
						if (legend.length) {
							label = legend.text();
							legend.hide();
						} else {
							label = cls.messages.tab_step_prefix + (index + 1);
						}

						// insert tab controller
						my.tabs.control.append(
							$("<li>", {
								'class': control_class
							}).append(
								$("<a>", {
									'href': '#'
								}).bind(
									"click", function(event) {
										event.preventDefault();
										cls.tab(index);
									}
								).html(label)
							)
						);

						my.tabs.items.push(fieldset);

						if (index !== 0) {
							fieldset.hide();
						}
					};

					fn.add_grouped_tab = function(set, group) {
						var a, control_class, container, fieldset;

						// get class name
						if (group === 0) {
							control_class = "first active";
						} else if (group === (my.options.tabs.length - 1)) {
							control_class = "last";
						} else {
							control_class = null;
						}

						// insert tab controller
						my.tabs.control.append(
							$("<li>", {
								'class': control_class
							}).append(
								$("<a>", {
									'href': '#'
								}).bind(
									"click", function(event) {
										event.preventDefault();
										cls.tab(group);
									}
								).html(set.title || cls.messages.tab_step_prefix + group)
							)
						);

						if ((container = form.find("div." + my.classes.tab_group).slice(group + 1, group + 2)).length === 0) {
							my.tabs.control.after(
								container = $("<div>", {
									'class': my.classes.tab_group
								})
							);
						}

						for (a = 0; a < set.fieldsets.length; a += 1) {
							if ((fieldset = $("#" + set.fieldsets[a])).length > 0) {
								container.append(fieldset);
							} else {
								my.log("Fieldset with id '" + set.fieldsets[a] + "' could not be found for grouping.");
							}
						}

						my.tabs.items.push(container);

						if (group !== 0) {
							container.hide();
						} else {
							container.show();
						}
					};

					if (my.options.tabs.length &&
						(my.options.tabs = $(my.options.tabs))) {
						// loop through each group and add
						my.options.tabs.each(function(index) {
							fn.add_grouped_tab(this, index);
						});
					} else if (my.options.tabs === true) {
						// loop through each fieldset and add
						fieldsets.each(function(index) {
							// add tab
							fn.add_tab($(this));
						});
					}

					my.tabs.index = 0;
				}
			},

			parse_element: function(element) {
				var name, id, title, value, label, label_text, type, collective;

				element = $(element);
				name = element.attr("name");
				id = element.attr("id");
				title = element.attr("title");
				type = element.attr("type");
				label = form.find("label[for='" + id + "']").first();
				//field = my.field(name);

				if (element.disabled) {
					// skip file and disabled elements
					my.log("Skipping disabled element '" + name + "'.");
					return;
				}

				collective = my.is_collective(element);

				if (id && label) {
					element.data("label", label);

					if (element.hasClass(my.classes.ph)) {
						if (title !== null) {
							if (collective) {
								throw new Error("Placeholders cannot be applied to collective element '" + name + "'.");
							}

							value = element.val();

							element.data(
								my.classes.ph, true
							).data(
								"title", title
							);

							if (value === "" || value === title) {
								element.val(title).removeClass(
									my.classes.ph_active
								).addClass(
									my.classes.ph_inactive
								);
							} else {
								element.addClass(my.classes.ph_active);
							}

							if ((label_text = label.find("." + my.classes.label_text).first()).length !== 1) {
								// if an element with the label_text class doesn't exist, the label is its own text element
								label_text = label;
							}

							if (label_text.length > 0) {
								label_text.hide();
							} else {
								my.log(
									"No label or element with class '" + my.classes.label_text +
									"' could be found for placeholder element '" + name + "'"
								);
							}
						} else {
							// title not supplied
							my.log("Placeholder requested but no title attribute supplied for '" +
								name + "'.");
						}
					} else {
						if (title !== null) {
							element.data(
								"title", title
							);
						}
					}

					element.bind("focus", function(event) {
						my.focus(event, name);
					});

					element.bind("blur", function(event) {
						my.focus(event, name);
					});
				} else if (!label && my.unlabelled.indexOf(type) === -1) {
					// element is unlabelled - do not apply dialog events
					my.log("Could not find label for element '" + name + "'.");
				}

				if (name !== null) {
					if (my.elements[name] && collective) {
						// add to a collective field
						if (my.elements[name].length === 1) {
							my.elements[name] = [my.elements[name]];
						}

						my.elements[name].push(element);
					} else {
						my.elements[name] = element;
					}
				}
			},

			event: function(event) {
				var element, field;

				element = $(event.target);

				switch (event.type) {
					case "submit":
						my.submit(event);
						break;

					case "click":
						if (element === my.ui.popup) {
							my.message("");
						}

						break;

					case "keyup":
						if (element.name &&
							(field = my.field(element.name)) &&
							typeof field === "object" &&
							field.live === true) {
							if (my.timers.live_validate) {
								window.clearTimeout(my.timers.live_validate);
								delete my.timers.live_validate;
							}

							my.timers.live_validate = window.setTimeout(function() {
								my.live_validate_field(element.name);
							}, (my.options.live_validate.delay * 1000));
						}
					}
			},

			submit: function(event) {
				var result, action, method;

				if (my.options.halt) {
					// stop form from submitting if halt is set
					event.preventDefault();
				}

				// clear all the placeholder elements
				my.clear();

				if ((result = cls.validate())) {
					// form is valid - handle (or not)
					method = form.attr("method");

					if (my.options.halt) {
						// only handle if halt is enabled
						if (typeof my.options.submit.callback !== "function" ||
							(typeof my.options.submit.callback === "function" &&
								my.options.submit.callback.apply(cls, [form]) !== false)) {
							// submit by appropriate method
							form.trigger("form:submitting", [
								my.options.submit.method || method
							]);

							switch (my.options.submit.method) {
								case WS.Form.SubmitMethods.POST:
								case WS.Form.SubmitMethods.GET:
									form.attr("method", my.options.submit.method);
									form[0].submit();
									break;

								case WS.Form.SubmitMethods.AJAX:
									action = form.attr("action") || "/";

									new $.ajax(action, {
										'data': form.serialize(),
										'type': 'POST',
										'success': function() {
											form.trigger("form:submitted", arguments);
										}
									});
									break;

								default:
									form[0].submit();
							}
						}
					}
				} else {
					// form is invalid
					my.report();

					if (result === false && !my.options.halt) {
						// stop if form is not valid - regardless of halt option
						event.preventDefault();
					}

					form.trigger("form:error", [
						form,
						my.faults
					]);
				}
			},

			validate: function(context, fields) {
				// validate form
				var name, field, result, a, ancestors, do_cascade;

				if (fields === undefined) {
					// first check - clear faults
					my.faults = [];
				}

				fields = fields || my.fields || null;

				do_cascade = function(cascade, value) {
					return (
						(typeof cascade.value === "undefined" && value !== "") ||
						(cascade.value === true && value !== "") ||
						(cascade.value === false && value === "") ||
						(cascade.value && cascade.value == value) ||
						(cascade.value && my.value_in_array(cascade.value, value))
					);
				};

				if (fields !== null) {
					for (name in fields) {
						if (fields.hasOwnProperty(name) && my.elements[name]) {
							// element exists in collection
							field = fields[name];

							if (context) {
								// get contextual element
								if (my.elements[name].constructor === Array && my.elements[name].length) {
									ancestors = $(my.elements[name][0]).ancestors();
								} else {
									ancestors = $(my.elements[name]).ancestors();
								}
							}

							if ((!context) || (context && ancestors.indexOf(context) !== -1)) {
								// element exists within context (or context is not defined)
								result = my.validate_field(name);

								if (result.valid === false) {
									my.faults.push(result);
								}

								if ((typeof field.cascade === "object" && result.valid === true)) {
									if (field.cascade.length) {
										for (a = 0; a < field.cascade.length; a += 1) {
											if (do_cascade(field.cascade[a], result.value)) {
												this.validate(context, field.cascade[a].fields);
											}
										}
									} else {
										if (do_cascade(field.cascade, result.value)) {
											this.validate(context, field.cascade.fields);
										}
									}
								}
							}
						}
					}
				}

				return (my.faults.length === 0);
			},

			live_validate_field: function(name, check) {
				// runs live validation on a field (which results in 'softer' messages)
				var result;

				check = check || my.field(name);
				result = my.validate_field(name, check, false);

				if (result.suggestion !== undefined) {
					// display a message
					my.message(
						cls.messages.did_you_mean + "&lsquo;<b>" + result.suggestion + "</b>&rsquo; ?",
						result.element, {
							'type': WS.Form.MsgTypes.Message
						}
					);
				} else {
					my.message("");
				}
			},

			validate_field: function(name, check) {
				// validate a single field
				var require_value, result, value, suggestion,
					num_value, el, duplicate_value,
					date, date_parts;

				check = check || my.field(name);
				el = my.elements[name];
				require_value = (check.require || check === true);

				result = new WS.Form.Result(name);

				if (check && el) {
					value = my.value(el);
					num_value = parseFloat(value);

					result.value = value;
					result.element = el;

					if ((typeof check === "object") || check === true) {
						if (require_value && (value === "" || value.length === 0)) {
							// value required
							result.valid = false;
						}

						// imply numeric when max/min are specified
						if (check.min !== undefined || check.max !== undefined) {
							check.type = WS.Form.ValueTypes.Number;
						}

						// value required or type constraint
						if (result.valid && check.type !== undefined) {
							switch (check.type) {
								case WS.Form.ValueTypes.Email:
									// test value for a valid email address
									if (!value.match(my.validation_re.email) && (value !== null || value !== "" || check.require)) {
										result.type = check.type;
										result.valid = false;
									} else {
										suggestion = my.utils.suggest_email(value);

										if (suggestion !== false && suggestion !== value) {
											result.suggestion = suggestion;
										}
									}
									break;

								case WS.Form.ValueTypes.Number:
									// test value for a valid number
									if (!value.match(my.validation_re.number) && (value !== "" || check.require)) {
										result.type = check.type;
										result.valid = false;
									}
									break;

								case WS.Form.ValueTypes.Date:
									// test value for a valid date (YYYY-MM-DD)
									if ((date = value.match(my.validation_re.date_iso))) {
										date_parts = [date[1], date[2], date[3]];
									} else if ((date = value.match(my.validation_re.date))) {
										date_parts = [date[4], date[3], date[1]];
									} else if (value !== "" || check.require) {
										result.type = check.type;
										result.valid = false;
									}

									if (date_parts) {
										// create date object
										if (date_parts[1] > 12 || date_parts[1] < 1) {
											result.type = check.type;
											result.valid = false;
										} else if (date_parts[2] > 31 || date_parts[2] < 1) {
											result.type = check.type;
											result.valid = false;
										} else {
											date = new Date(date_parts[0], date_parts[1], date_parts[2]);

											if (isNaN(date.valueOf())) {
												result.type = check.type;
												result.valid = false;
											}
										}
									}
									break;

								case WS.Form.ValueTypes.RegExp:
									// test value against a regexp
									if (check.regexp) {
										if (!check.regexp.test(value) && (value !== "" || check.require)) {
											result.type = check.type;
											result.valid = false;
										}
									}
									break;

								default:
									my.log("Invalid check type defined for field '" + name + "'");
							}
						}

						// value required or min/max numeric amount constraints
						if (result.valid) {
							if ((check.min !== undefined || check.max !== undefined) &&
								!isNaN(num_value)) {
								if (check.min !== undefined && num_value < check.min) {
									result.value_min = true;
									result.required_value = check.min;
									result.valid = false;
								}

								if (check.max !== undefined && num_value > check.max) {
									result.value_max = true;
									result.required_value = check.max;
									result.valid = false;
								}
							}

							// run the folowing constraints if there is a value
							if (value.length > 0) {
								// min length constraint
								if (check.min_len !== undefined &&
									value.length < check.min_len) {
									result.value_min_len = true;
									result.required_value = check.min_len;
									result.valid = false;
								}

								// max length constraint
								if (check.max_len !== undefined && value.length > check.max_len) {
									result.value_max_len = true;
									result.required_value = check.max_len;
									result.valid = false;
								}
							}
						}

						if (check.duplicate_of && my.elements[check.duplicate_of] !== undefined) {
							duplicate_value = my.value(my.elements[check.duplicate_of]);

							if (duplicate_value !== value) {
								result.mismatch = check.duplicate_of;
								result.valid = false;
							}
						}
					}

					return result;
				} else {
					if (!check) {
						// validate_field() has most likely been run manually but no requirement exists for this element
						return result;
					} else {
						throw new Error("Element '" + name + "' could not be found within the form");
					}
				}
			},

			clear: function(field_name) {
				// clear all fields before submission
				var field, el, fn;

				fn = {
					highlight: function() {
						my.highlight($(this), false);
					}
				};

				for (field in my.elements) {
					if (my.elements.hasOwnProperty(field) &&
						(field === field_name || field_name === undefined)) {
						el = my.elements[field];

						if (el.length > 1) {
							// array of elements
							$(el).each(fn.highlight);
						} else {
							// single element
							if (el.data(my.classes.ph) === true && el.val() === el.data("title")) {
								// clear placeholder field
								el.val("");
							}

							my.highlight(el, false);
						}
					}
				}
			},

			restore_placeholders: function(field_name) {
				// restore placeholders to all fields
				var field, el;

				for (field in my.elements) {
					if (my.elements.hasOwnProperty(field) &&
						(field === field_name || field_name === undefined)) {
						el = my.elements[field];

						if (el.length === 1) {
							// single element
							if (el.data(my.classes.ph) === true && el.val() === "") {
								// restore placeholder field
								el.val(el.data("title"));
							}
						}
					}
				}
			},

			report: function(context) {
				// highlights form elements within the my.faults array
				var field, fn, a, top_pos, field_top;

				fn = function() {
					field = my.elements[this.name];

					my.log("'" + this.name + "' found to contain fault(s).");

					if (field.length > 1) {
						for (a = 0; a < field.length; a += 1) {
							my.highlight(field[a]);

							if (top_pos === undefined) {
								if (field[a].closest('.content').length && $.contains(form[0], field[a].closest('.content')[0])) {
									field_top = field[a].closest('.content').offset().top;
								} else {
									field_top = field[a].closest('div').offset().top;
								}
							}
						}
					} else {
						my.highlight(field);

						if (field.closest('.content').length && $.contains(form[0], field.closest('.content')[0])) {
							field_top = field.closest('.content').offset().top;
						} else {
							field_top = field.closest('div').offset().top;
						}

					}

					if (top_pos === undefined || top_pos > field_top) {
						top_pos = field_top;
					}
				};

				if (my.faults.length > 0) {
					// highlight faulty elements
					$(my.faults).each(fn);

					// scroll to first highlighted error
					$('html, body').animate({scrollTop: top_pos}, 300);

					if (context === undefined) {
						context = form;
					}

					my.message(cls.messages.general_error, context, {
						'type': WS.Form.MsgTypes.Error
					});
				}

				return my.faults.length;
			},

			reset: function() {
				// reset required elements to base state
				var field, fn, a;

				fn = function() {
					field = my.elements[this.name];

					my.log("resetting '" + this.name + "'.");

					if (field.length > 1) {
						for (a = 0; a < field.length; a += 1) {
							my.highlight(field[a], false);
						}
					} else {
						my.highlight(field, false);

						my.focus("blur", this.name);
					}
				};

				// unclear form placeholders
				my.restore_placeholders();

				if (my.faults.length > 0) {
					// remove all faults
					$(my.faults).each(fn);

					my.faults = [];

					my.message("");
				}
			},

			highlight: function(field, highlight) {
				var label, parent, description;

				label = field.data("label");

				if (highlight === undefined) {
					highlight = true;
				}

				if (label !== undefined) {
					parent = label.parent().first();
					description = parent.next('.description');

					if (highlight) {
						label.addClass("required");
					} else {
						label.removeClass("required");
					}

					if (parent.length && $.contains(form[0], parent[0])) {
						// highlight parent
						if (highlight) {
							parent.addClass("required");
						} else {
							parent.removeClass("required");
						}
					}

					if (description.length && $.contains(form[0], description[0])) {
						// highlight parent
						if (highlight) {
							description.addClass("error");
						} else {
							description.removeClass("error");
						}
					}
				}
			},

			focus: function(event, name) {
				var fault, el, field, options, placeholder, field_label, message, title;

				if (!my.elements[name]) {
					return;
				}

				el = my.elements[name];
				field = my.field(name);
				options = my.options.field.popup;

				if (field && field.popup && field.popup.alignment) {
					options.alignment = field.popup.alignment;
				}

				if (event.type === "focus") {
					// element is being focused
					fault = my.fault(name);

					if (el) {
						if (!$.isArray(el)) {
							title = el.data("title");
							placeholder = (el.data(my.classes.ph) === true);

							if (placeholder && my.value(el) === el.data("title")) {
								el.val("").removeClass(
									my.classes.ph_inactive
								).addClass(
									my.classes.ph_active
								);
							}
						}

						if (fault) {
							// fault exists for this field
							if (fault.type) {
								if (field && field.messages && field.messages.type) {
									message = field.messages.type;
								} else {
									switch (fault.type) {
										case WS.Form.ValueTypes.Email:
											message = cls.messages.type_email;
											break;

										case WS.Form.ValueTypes.Number:
											message = cls.messages.type_number;
											break;

										case WS.Form.ValueTypes.Date:
											message = cls.messages.type_date;
											break;

										case WS.Form.ValueTypes.RegExp:
											message = cls.messages.type_regex;
											break;
									}
								}
							} else if (fault.value_min) {
								if (field.messages && field.messages.value_min) {
									message = field.messages.value_min;
								} else {
									message = cls.messages.value_min;
								}
							} else if (fault.value_max) {
								if (field.messages && field.messages.value_max) {
									message = field.messages.value_max;
								} else {
									message = cls.messages.value_max;
								}
							} else if (fault.value_max_len) {
								if (field.messages && field.messages.value_max_len) {
									message = field.messages.value_max_len;
								} else {
									message = cls.messages.value_max_len;
								}
							} else if (fault.value_min_len) {
								if (field.messages && field.messages.value_min_len) {
									message = field.messages.value_min_len;
								} else {
									message = cls.messages.value_min_len;
								}
							} else if (fault.mismatch) {
								// field mismatched to its duplicate
								field_label = my.element_label(my.elements[fault.mismatch]);

								if (field.messages && field.messages.mismatch) {
									message = field.messages.mismatch;
								} else {
									message = cls.messages.field_mismatch;
								}
							} else {
								// basic field value
								if (field && field.messages && field.messages.require) {
									message = field.messages.require;
								} else {
									message = cls.messages.field_value;
								}
							}

							if (typeof message === "string") {
								message = message.replace(/\$1/, field_label || "");
								message = message.replace(/\$2/, fault.required_value);
								message = message.replace(/\$3/, fault.value);
							} else {
								message = "";
							}

							// placeholder elements
							if ((placeholder || my.options.field.popup.show_name) && title) {
								message = title + " - " + message;
							}

							options.type = WS.Form.MsgTypes.Error;

							my.message(message, el, options);
						} else if (placeholder) {
							my.message(title, el, options);
						} else {
							// nothing to display
							my.message("");
						}
					}
				} else {
					// element is being blurred (or not focused)
					if (el && !$.isArray(el)) {
						placeholder = (el.data(my.classes.ph) === true);

						if (placeholder && my.value(el) === "") {
							if ($.inArray(el.attr("type"), my.nontext_input_types) === -1) {
								// field is a text-based input - set the value to the title
								el.val(el.data("title"));
							}

							el.removeClass(
								my.classes.ph_active
							).addClass(
								my.classes.ph_inactive
							);
						}
					}

					my.message("");
				}
			},

			field: function(find, fields) {
				// attempt to find an item within this.fields based on name
				var item, name, a;

				fields = fields || my.fields;

				for (name in fields) {
					if (fields.hasOwnProperty(name)) {
						if (item !== undefined) {
							break;
						}

						if (name === find) {
							item = fields[name];
						}

						if (item === undefined && fields[name].cascade) {
							if (fields[name].cascade.length) {
								for (a = 0; a < fields[name].cascade.length; a += 1) {
									if (typeof fields[name].cascade[a].fields === "object") {
										item = my.field(find, fields[name].cascade[a].fields);

										if (item !== undefined) {
											break;
										}
									}
								}
							} else if (typeof fields[name].cascade.fields === "object") {
								item = my.field(find, fields[name].cascade.fields);
							}
						}
					}
				}

				return item;
			},

			value: function(el) {
				// get element value
				var a, values, value, result;

				if (typeof el === "string") {
					if (my.elements[el]) {
						el = my.elements[el];
					} else {
						throw new Error("Element '" + arguments[0] + "' could not be found");
					}
				}

				if (el.length > 1) {
					// return multiple items
					values = "";

					for (a = 0; a < el.length; a += 1) {
						if (el[a].attr("type") === "radio") {
							// only one value is collected
							if ((value = my.element_value(el[a]))) {
								values = value;
								break;
							}
						} else {
							// multiple values are collected
							if ((value = my.element_value(el[a]))) {
								if (values === "") {
									values = [];
								}

								values.push(value);
							}
						}
					}

					result = values;
				} else {
					// return single item
					result = my.element_value(el);
				}

				return result;
			},

			element_value: function(el) {
				// gets the value of a single element
				var value;

				value = "";

				if (my.is_collective(el)) {
					if (el.prop("checked")) {
						value = el.val() || "";
					}
				} else {
					value = el.val() || "";

					if (typeof value === "string") {
						value = $.trim(value);
					}
				}

				return value;
			},

			element_label: function(el) {
				// attempt to data the element's label
				var label, span;

				label = el.data("label");

				if (label) {
					span = label.children(my.classes.label_text).first();

					if (span.length > 0) {
						// span with a class of label-text exists
						return (span.text());
					} else {
						// get entire label text content
						return (label.text());
					}
				} else {
					// no label - just get the title attribute
					return el.attr("title");
				}
			},

			is_collective: function(el) {
				var key;

				for (key in my.collectives) {
					if (my.collectives.hasOwnProperty(key) &&
						el.is(my.collectives[key])) {
						return true;
					}
				}

				return false;
			},

			value_in_array: function(value, array) {
				// attempt to find [value] in [array]
				var a;

				if (!array.length) {
					return false;
				}

				if (typeof value === "string") {
					return (array.indexOf(value) !== -1);
				} else if (value.length) {
					for (a = 0; a < value.length; a += 1) {
						if (array.indexOf(value[a]) !== -1) {
							return true;
						}
					}
				}

				return false;
			},

			fault: function(find) {
				// attempt to find a fault
				var item;

				for (item in my.faults) {
					if (my.faults.hasOwnProperty(item) && my.faults[item].name === find) {
						return my.faults[item];
					}
				}
			},

			message: function(message, context, options) {
				var popup;

				options = ob_set(options || {}, my.options.popup);

				if (options.handler) {
					popup = options.handler;
				} else {
					popup = my.popup;
				}

				if (message !== "") {
					context = context || form;

					if (context === form) {
						// context is the entire form
						if (my.controls.submit) {
							// place at last submit button
							context = my.controls.submit;
						} else {
							// keep at form level
							context = form;
						}
					}

					if (context.length > 1) {
						context = context[0];
					}

					popup.apply(cls, [context, options, message]);
				} else {
					popup.apply(cls);
				}
			},

			popup: function(context, options, message) {
				var form_size, context_size, context_class, popup_size, context_pos;

				my.ui.popup.attr("class", my.classes.popup);

				if (context === undefined || context == form) {
					context_class = ['global'];
				} else if (context.length) {
					context_class = [context[0].tagName.toLowerCase()];

					if (context.attr("type")) {
						context_class.push(context.attr("type").toLowerCase());
					}
				}

				my.ui.popup.addClass("context-" + context_class.join("-"));

				if (message !== undefined) {
					switch (options.type) {
						case WS.Form.MsgTypes.Error:
							my.ui.popup.addClass("popup-type-error");
							break;

						case WS.Form.MsgTypes.Message:
							my.ui.popup.addClass("popup-type-message");
							break;
					}

					my.ui.popup.css({
						'display': 'block',
						'visibility': 'hidden',
						'width': 'auto'
					}).html(message);

					// obtain metrics for form, context and popup
					context_pos = context.formOffset();

					form_size = {
						'width': form.width()
					};

					context_size = {
						'height': context.outerHeight(),
						'width': context.outerWidth()
					};

					popup_size = {
						'height': my.ui.popup.outerHeight(),
						'width': my.ui.popup.outerWidth()
					};

					if (popup_size.width > form_size.width) {
						// make sure the popup is no larger than the form
						my.ui.popup.css({
							'width': form_size.width + 'px',
							'whiteSpace': 'normal'
						});

						// update metrics
						popup_size = {
							'height': my.ui.popup.outerHeight(),
							'width': my.ui.popup.outerWidth()
						};
					}

					switch (options.alignment) {
						case WS.Form.Alignments.bottom_left:
							my.ui.popup.css({
								'top': (context_pos.top + context_size.height + options.margin) + 'px',
								'left': context_pos.left + 'px'
							});
							break;

						case WS.Form.Alignments.bottom_right:
							my.ui.popup.css({
								'top': (context_pos.top + context_size.height + options.margin) + 'px',
								'left': (context_pos.left - (popup_size.width - context_size.width)) + 'px'
							});
							break;

						case WS.Form.Alignments.top_left:
							my.ui.popup.css({
								'top': ((context_pos.top - popup_size.height) - options.margin) + 'px',
								'left': context_pos.left + 'px'
							});
							break;

						case WS.Form.Alignments.top_center:
							my.ui.popup.css({
								'top': ((context_pos.top - popup_size.height) - options.margin) + 'px',
								'left': (context_pos.left - (popup_size.width / 2) + (context_size.width / 2)) + 'px'
							});
							break;

						case WS.Form.Alignments.bottom_center:
							my.ui.popup.css({
								'top': (context_pos.top + context_size.height + options.margin) + 'px',
								'left': (context_pos.left - (popup_size.width / 2) + (context_size.width / 2)) + 'px'
							});
							break;

						default:
							my.ui.popup.css({
								'top': ((context_pos.top - popup_size.height) - options.margin) + 'px',
								'left': (context_pos.left - (popup_size.width - context_size.width)) + 'px'
							});
							break;
					}

					my.ui.popup.css({
						'visibility': 'visible'
					});
				} else {
					my.ui.popup.hide();
				}
			},

			log: function(msg) {
				// log event to the console (if active)
				if (typeof console !== "undefined") {
					console.log(msg);
				}
			},

			utils: {
				suggest_email: function(email) {
					// returns a 'suggestion' email (or the same email if none found)
					var a, parts, closest, min_distance, distance_threshold, find_domain;

					if (typeof email === "string") {
						parts = email.match(my.validation_re.email_parts);

						if (parts && parts.length === 4) {
							parts = {
								'email': parts[0],
								'user': parts[1],
								'domain': parts[2] + '.' + parts[3],
								'tld': parts[3]
							};

							min_distance = 99;
							closest = null;
							distance_threshold = 3;

							find_domain = function(domain, data) {
								// find domain
								var closest, a, data_domain, dist;

								closest = null;

								for (a = 0; (data_domain = data[a]); a += 1) {
									if (data_domain === domain) {
										// domain is exactly this one
										closest = domain;
										break;
									}

									// get distance
									dist = my.utils.sift3_distance(data_domain, domain);

									if (dist < min_distance) {
										closest = data_domain;
										min_distance = dist;
									}
								}

								if (min_distance < distance_threshold && closest !== null) {
									// domain is close to a stored domain
									if (closest !== domain) {
										return closest;
									} else {
										return null;
									}
								} else {
									return null;
								}
							};

							closest = find_domain(parts.domain, my.data.mail_domains);

							if (closest !== null) {
								if (closest !== parts.domain) {
									return closest;
								} else {
									return false;
								}
							} else {
								return false;
							}
						} else {
							return false;
						}
					} else {
						return false;
					}
				},

				sift3_distance: function(s1, s2) {
					// sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
					var i, c, offset1, offset2, lcs, max_offset;

					if (s1 === null || s1 === undefined || s1.length === 0) {
						if (s2 === null || s2 === undefined || s2.length === 0) {
							return 0;
						} else {
							return s2.length;
						}
					}

					if (s2 === null || s2 === undefined || s2.length === 0) {
						return s1.length;
					}

					c = 0;
					offset1 = 0;
					offset2 = 0;
					lcs = 0;
					max_offset = 5;

					while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
						if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
							lcs += 1;
						} else {
							offset1 = 0;
							offset2 = 0;

							for (i = 0; i < max_offset; i += 1) {
								if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
									offset1 = i;
									break;
								}

								if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
									offset2 = i;
									break;
								}
							}
						}

						c += 1;
					}

					return ((s1.length + s2.length) / 2 - lcs);
				}
			}
		};

		my.enable();

		return cls;
	};

	/**
	 * @property WS.Form.ValueTypes
	 */
	WS.Form.ValueTypes = {
		'Email': 1,
		'Number': 2,
		'RegExp': 3,
		'Date': 4
	};

	/**
	 * @property WS.Form.Fields
	 * @memberof WS.Form
	 * @description
	 * An object containing multiple {@link WSFormRequirement} objects, the key of each object
	 * referencing the name of the field.
	 * @example
	 * // full requirement object
	 * WS.Form.Fields['formname'] = {
	 *     'fieldname': {
	 *         'required': true
	 *     }
	 * }
	 * @example
	 * // shorthand version
	 * WS.Form.Fields['formname'] = {
	 *     'fieldname': true
	 * }
	 */
	WS.Form.Fields = {};

	/**
	 * @property WS.Form.MsgTypes
	 * @property WS.Form.MsgTypes.Error - Error message.
	 * @property WS.Form.MsgTypes.Message - Standard message.
	 */
	WS.Form.MsgTypes = {
		'Error': 1,
		'Message': 2
	};

	/**
	 * @property WS.Form.Messages
	 */
	WS.Form.Messages = {
		'general_error': 'Please check for errors before sending',
		'field_value': 'Must be filled in',
		'field_mismatch': 'Must be identical to \'$1\'',
		'tab_step_prefix': 'Step ',
		'type_email': 'Must be a valid email',
		'type_number': 'Must be a valid number',
		'type_regex': 'Value is in an incorrect format',
		'type_date': 'Value is an invalid date',
		'value_min': 'Value must be a minimum of $2',
		'value_max': 'Value must be a maximum of $2',
		'value_min_len': 'Must contain a minimum $2 characters',
		'value_max_len': 'Must contain a maximum $2 characters',
		'did_you_mean': 'Did you mean '
	};

	/**
	 * @property WS.Form.Alignments
	 * @property WS.Form.Alignments.top_left - Align to the top left of the context.
	 * @property WS.Form.Alignments.top_right - Align to the top right of the context.
	 * @property WS.Form.Alignments.bottom_left - Align to the bottom left of the context.
	 * @property WS.Form.Alignments.bottom_right - Align to the bottom right of the context.
	 * @property WS.Form.Alignments.top_center - Align to the top center of the context.
	 * @property WS.Form.Alignments.bottom_center - Align to the bottom center of the context.
	 */
	WS.Form.Alignments = {
		'top_left': 1,
		'top_right': 2,
		'bottom_left': 3,
		'bottom_right': 4,
		'top_center': 5,
		'bottom_center': 6
	};

	/**
	 * @property {object} WS.Form.SubmitMethods
	 * @property {string} WS.Form.SubmitMethods.POST - Submits the form with POST.
	 * @property {string} WS.Form.SubmitMethods.GET - Submits the form with GET
	 * @property {string} WS.Form.SubmitMethods.AJAX - Submits the form using a generic AJAX request.
	 */
	WS.Form.SubmitMethods = {
		'POST': 'post',
		'GET': 'get',
		'AJAX': 'ajax'
	};

	/**
	 * @class
	 * @arg {string} name - Name attribute of the field this instance applies to.
	 * @arg {Object} options - See properties for option keys/values.
	 */
	WS.Form.Result = function(name, options) {
		var result;

		/**
		 * @property {string} name - Name of the field.
		 * @property {boolean} valid - `true` if the field is 'valid', `false` otherwise.
		 * @property {string|Array} required_value - The required value.
		 * @property {string|Array} value - The computed value.
		 */
		result = ob_set(options || {}, {
			'valid': true,
			'required_value': '',
			'value': ''
		});

		result.name = name;

		return result;
	};
}(window.jQuery, window.ob_set));
